import React from 'react';

import { BreakoutContainer } from './styles';

interface IBreakoutProps {
  title: string;
  content: React.JSX.Element[];
}

const Breakout = ({ title, content }: IBreakoutProps) => (
  <BreakoutContainer className="breakout">
    <div className="breakout__content">
      <h2>{title}</h2>
      <div className="breakout__items">
        {content.map((jsx, index) => (
          <div className="breakout__items__item" key={index}>
            {jsx}
          </div>
        ))}
      </div>
    </div>
    <div className="breakout__spacer"></div>
  </BreakoutContainer>
);

export { Breakout };
